<nav
  aria-label="breadcrumbs"
  class="breadcrumbs"
  *ngIf="!isLoading; else loadingBreadcrumbs"
>
  <div class="container">
    <ol
      class="breadcrumb"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
        <li
          class="breadcrumb-item"
          [ngClass]="{ active: i === breadcrumbs.length - 1 }"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <span class="breadcrumb-item-wrapper">
            <ng-container *ngIf="i !== 0">
              <hdi-icon
                [iconName]="'arrow-right-long'"
                [iconPrefix]="'far'"
                [color]="
                  i === breadcrumbs.length - 1 ? Colors.BLACK : Colors.GREY
                "
                [size]="Sizes.XSMALL"
                [style.margin]="'0 0.25rem'"
              ></hdi-icon>
            </ng-container>
            <hdi-link
              *ngIf="breadcrumb.url"
              [label]="breadcrumb.title"
              [type]="breadcrumbNoIconType"
              [hrefType]="BreadcrumbHrefType.ANGULAR_ROUTE"
              [href]="breadcrumb.url"
              [color]="
                i === breadcrumbs.length - 1 ? Colors.BLACK : Colors.GREY
              "
            ></hdi-link>
            <span *ngIf="!breadcrumb.url" class="current" itemprop="title">{{
              breadcrumb.title
            }}</span>
          </span>
          <span>
            <span [innerHTML]="getMetaTagHtml(i)"></span>
          </span>
        </li>
      </ng-container>
    </ol>
  </div>
</nav>

<!-- Loading Placeholder TEST SHOULD NOT BE PERFORMED BEFORE #loadingBreadcrumbs DISAPPEARS -->
<ng-template #loadingBreadcrumbs>
  <div class="breadcrumbs breadcrumbs--loader">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        'margin-bottom': '0',
        'background-color': '#f9f9fa',
      }"
    ></ngx-skeleton-loader>
    <div class="container bg-loader">
      <div class="breadcrumb breadcrumb--loader">
        <ng-container
          *ngFor="let breadcrumb of [].constructor(2); let i = index"
        >
          <div class="breadcrumb-item">
            <span
              class="breadcrumb-item-wrapper breadcrumb-item-wrapper--loader"
            >
              <ng-container *ngIf="i !== 0">
                <div class="icon-loader">
                  <ngx-skeleton-loader
                    [theme]="{
                      width: '100%',
                      height: '100%',
                      'margin-bottom': '0',
                    }"
                  ></ngx-skeleton-loader>
                </div>
              </ng-container>
              <div class="link-loader">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '100%',
                    height: '100%',
                    'margin-bottom': '0',
                  }"
                ></ngx-skeleton-loader>
              </div>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
